"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalType = exports.BaseProposalAnswerValue = void 0;
var BaseProposalAnswerValue;
(function (BaseProposalAnswerValue) {
    BaseProposalAnswerValue[BaseProposalAnswerValue["YES"] = 1] = "YES";
    BaseProposalAnswerValue[BaseProposalAnswerValue["NO"] = 0] = "NO";
})(BaseProposalAnswerValue || (exports.BaseProposalAnswerValue = BaseProposalAnswerValue = {}));
/**
 * Proposal Types.
 */
var ProposalType;
(function (ProposalType) {
    ProposalType[ProposalType["NATIVE"] = 0] = "NATIVE";
    ProposalType[ProposalType["MEMBERS"] = 1] = "MEMBERS";
    ProposalType[ProposalType["ADD_GUARDIAN"] = 2] = "ADD_GUARDIAN";
    ProposalType[ProposalType["REMOVE_GUARDIAN"] = 3] = "REMOVE_GUARDIAN";
    ProposalType[ProposalType["EDIT_SPACE"] = 4] = "EDIT_SPACE";
    ProposalType[ProposalType["REMOVE_STAKE_REWARD"] = 5] = "REMOVE_STAKE_REWARD";
})(ProposalType || (exports.ProposalType = ProposalType = {}));
